<form [formGroup]="formGroup">
  <div class="d-flex flex-column">
    <span
      class="small-title"> {{'proposalDetails.createOfferTab.individualInformationSection.title'|translate}}</span>


    <div class="d-flex field-container">
      <app-input-field [label]="'proposalDetails.createOfferTab.individualInformationSection.defaultTerms'|translate"
                       [control]="formGroup.controls.defaultTerms"
                       class="w-100">

        <mat-select formControlName="defaultTerms"
                    class=" input"
                    [value]="formGroup.controls.defaultTerms" [multiple]="true" #multiSelect>
          <mat-option>
            <ngx-mat-select-search
              [formControl]="filterCtrlDefaultTerms" ngDefaultControl></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let option of filteredOptionsDefaultTerms |async"
                      [value]="option">
            {{option}}
          </mat-option>

        </mat-select>
      </app-input-field>
    </div>


    <div class="d-flex field-container">
      <app-input-field [label]="'proposalDetails.createOfferTab.individualInformationSection.individualTerms'|translate"
                       [control]="formGroup.controls.individualTerms"
                       class="w-100">
      <textarea name="individualTerms"
                formControlName="individualTerms"
                cdkTextareaAutosize
                [cdkAutosizeMinRows]="3"
                class="input input-text-area"> </textarea>

      </app-input-field>
    </div>

    <div class="d-flex field-container">
      <app-input-field [label]="'proposalDetails.createOfferTab.individualInformationSection.defaultClauses'|translate"
                       [control]="formGroup.controls.defaultClauses"
                       class="w-100">

        <mat-select formControlName="defaultClauses"
                    class=" input"
                    [value]="formGroup.controls.defaultClauses" [multiple]="true" #multiSelect>
          <mat-option>
            <ngx-mat-select-search
              [formControl]="filterCtrlDefaultClauses" ngDefaultControl></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let option of filteredOptionsDefaultClauses |async"
                      [value]="option">
            {{option}}
          </mat-option>

        </mat-select>
      </app-input-field>
    </div>

    <div class="d-flex field-container">
      <app-input-field
        [label]="'proposalDetails.createOfferTab.individualInformationSection.individualClauses'|translate"
        [control]="formGroup.controls.individualClauses"
        class="w-100">
      <textarea name="individualClauses"
                formControlName="individualClauses"
                cdkTextareaAutosize
                [cdkAutosizeMinRows]="3"
                class="input input-text-area"> </textarea>
      </app-input-field>
    </div>

    <app-offer-file-upload (uploadInProgress)="sendUploadStatus($event)"></app-offer-file-upload>
    <hr>
    <span
      class="small-title"> {{'offer.createOffer.individualInformationSection.otherInformation'|translate}}</span>
    <div class="d-flex field-container">
      <app-input-field
        [label]=""
        [control]="formGroup.controls.otherInformation"
        class="w-100">
      <textarea
        placeholder="{{'offer.createOffer.individualInformationSection.otherInformationPlaceholder' | translate}}"
        name="otherInformation"
        formControlName="otherInformation"
        cdkTextareaAutosize
        [cdkAutosizeMinRows]="3"
        class="input input-text-area"> </textarea>
      </app-input-field>
    </div>
  </div>
</form>
